import * as React from "react";
import Navbar from "../components/nav-bar";
import Footer from "../components/footer";
import Banner from "../components/banner";
import SEO from "../components/seo";
import { Row, Container, Col } from "react-bootstrap";
import { graphql, useStaticQuery } from "gatsby";
import ReactMarkdown from "react-markdown";
const OurStory = () => {
  const { strapiOurStory } = useStaticQuery(pageQuery);
  const { content } = strapiOurStory;
  return (
    <div className="outer-container">
      <Navbar></Navbar>
      <SEO
        title={`We are here to serve the Irish SME | Financial Consultation | Finance | Ireland | Best Ireland Finance Services`}
        description={
          "Consultation, Finance, Business Loans & Grants, Assets Finance & Leasing, Other Finance Options"
        }
      ></SEO>
      <Container fluid className="p-0 overflow-hidden">
        <Banner title="Our Story" backgroundClass="home-img"></Banner>
        <Row className="article p-5">
          <Col>
          <ReactMarkdown>{content}</ReactMarkdown>
          </Col>
        </Row>
        <Footer></Footer>
      </Container>
    </div>
  );
};

export default OurStory;

export const pageQuery = graphql`
  query OurStoryPageDataQuery {
    strapiOurStory {
          content
    }
  }
`;
